import Vue from 'vue';
import axios from '@/services/axios';
import api from '@/services/api';
import session from '@/services/session';
import userLocalStorage from '@/services/userLocalStorage';
import abilities from '@/services/abilities';

Vue.prototype.$session = session;
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.$userLocalStorage = userLocalStorage;
Vue.prototype.$abilities = abilities;
